import BrandInfo from './BrandSection.View';

export default BrandInfo;
